(() => {
  'use strict';

  const SORT_LABELS = new Map([
    ['best-selling', 'Bestsellere'],
    ['price-ascending', 'Pris: lav til høj'],
    ['price-descending', 'Pris: høj til lav'],
    ['created-descending', 'Nyeste'],
  ]);

  const LEGACY_SEASON_LABELS = new Map([
    ['helaar', 'helår'],
    ['foraar-paaske', 'forår & påske'],
    ['sommer', 'sommer'],
    ['efteraar', 'efterår'],
    ['jul', 'jul'],
  ]);

  const stockOnlyShell = () => document.querySelector(
    '.nbh-collection-shell[data-nbh-in-stock-only="true"][data-nbh-availability-filter-ready="true"]'
  );

  const ensureStockOnlyUrl = (url) => {
    const normalized = new URL(url, window.location.origin);
    if (stockOnlyShell()) normalized.searchParams.set('filter.v.availability', '1');
    return normalized;
  };

  const migrateLegacyFilterUrl = () => {
    const url = new URL(window.location.href);
    let changed = false;

    if (stockOnlyShell() && url.searchParams.get('filter.v.availability') !== '1') {
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      changed = true;
    }

    const legacySeason = url.searchParams.get('nbh_season');
    if (legacySeason && LEGACY_SEASON_LABELS.has(legacySeason)) {
      const targetLabel = LEGACY_SEASON_LABELS.get(legacySeason);
      const option = [...document.querySelectorAll('input[name="filter.p.m.custom.seasons"]')]
        .find((input) => input.closest('label')?.textContent.trim().toLocaleLowerCase('da-DK').startsWith(targetLabel));
      if (option) {
        url.searchParams.delete('nbh_season');
        url.searchParams.append('filter.p.m.custom.seasons', option.value);
        changed = true;
      }
    }

    const legacyBestseller = url.searchParams.get('nbh_bestseller');
    if (legacyBestseller === '1' || legacyBestseller === 'true') {
      url.searchParams.delete('nbh_bestseller');
      url.searchParams.set('filter.p.m.custom.bestseller', '1');
      changed = true;
    }

    if (url.searchParams.get('filter.p.m.custom.bestseller') === 'true') {
      url.searchParams.set('filter.p.m.custom.bestseller', '1');
      changed = true;
    }

    if (!changed) return false;

    window.location.replace(url.toString());
    return true;
  };


  let requestController = null;

  const DRAWER_MEDIA = window.matchMedia('(max-width: 960px)');
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  const visibleFocusableElements = (container) => [...container.querySelectorAll(FOCUSABLE_SELECTOR)]
    .filter((element) => !element.hidden && element.getClientRects().length > 0);

  const syncBestsellerVisibility = (shell) => {
    const input = shell?.querySelector('[data-nbh-filter="bestseller"]');
    const row = input?.closest('.nbh-prototype-filter-bestseller');
    const count = row?.querySelector('.nbh-prototype-filter-count');
    if (!input || !row || !count) return;
    const hasBestsellers = Number.parseInt(count.textContent || '0', 10) > 0;
    row.hidden = !hasBestsellers && !input.checked;
  };

  const polishSort = () => {
    document.querySelectorAll('.nbh-catalog-sort select[name="sort_by"]').forEach((select) => {
      [...select.options].forEach((option) => {
        const customLabel = SORT_LABELS.get(option.value || '');
        if (customLabel) option.textContent = `Sortér: ${customLabel}`;
        else option.textContent = option.textContent.replace(/^Sortér:\s*/i, 'Sortér: ');
      });
    });
  };

  const hideUnavailableFilters = (shell) => {
    shell.dataset.nbhFilterEngine = 'server';
    shell.querySelectorAll('[data-nbh-prototype-filters]').forEach((panel) => {
      panel.hidden = true;
      panel.classList.remove('is-open');
    });
    const trigger = shell.querySelector('.nbh-catalog-toolbar [data-nbh-filter-open]');
    if (trigger) trigger.hidden = true;
    shell.querySelectorAll('[data-nbh-filter-overlay]').forEach((overlay) => overlay.remove());
    document.body.classList.remove('nbh-filter-drawer-open');
  };

  const buildSectionUrl = (url, sectionId) => {
    const requestUrl = ensureStockOnlyUrl(url);
    requestUrl.searchParams.delete('section_id');
    requestUrl.searchParams.set('section_id', sectionId);
    return requestUrl;
  };

  const publicUrlFor = (url) => {
    const publicUrl = ensureStockOnlyUrl(url);
    publicUrl.searchParams.delete('section_id');
    return publicUrl;
  };

  const buildFilterParams = (form) => {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');

    const shell = form.closest('.nbh-collection-shell');
    const visibleSort = shell?.querySelector('.nbh-catalog-sort select[name="sort_by"]')?.value || '';

    const ownedNames = new Set(
      [...form.querySelectorAll('[name]')]
        .map((field) => field.name)
        .filter(Boolean)
    );

    ownedNames.forEach((name) => params.delete(name));

    if (stockOnlyShell()) params.set('filter.v.availability', '1');

    const formData = new FormData(form);
    formData.forEach((value, name) => {
      if (name !== 'sort_by' && String(value).trim() !== '') params.append(name, value);
    });

    if (visibleSort) params.set('sort_by', visibleSort);
    else params.delete('sort_by');

    return params;
  };

  const syncSortState = (shell, sourceShell, targetUrl) => {
    if (!shell) return;

    const publicUrl = publicUrlFor(targetUrl);
    const sourceSelect = sourceShell?.querySelector('.nbh-catalog-sort select[name="sort_by"]');
    const sortValue = publicUrl.searchParams.get('sort_by') || sourceSelect?.value || '';

    const visibleSelect = shell.querySelector('.nbh-catalog-sort select[name="sort_by"]');
    if (visibleSelect && sortValue && [...visibleSelect.options].some((option) => option.value === sortValue)) {
      visibleSelect.value = sortValue;
    }

    const hiddenSort = shell.querySelector('[data-nbh-server-filter-form] input[name="sort_by"]');
    if (hiddenSort) hiddenSort.value = sortValue;
  };

  const withCurrentSort = (shell, targetUrl) => {
    const url = new URL(targetUrl, window.location.origin);
    const visibleSort = shell?.querySelector('.nbh-catalog-sort select[name="sort_by"]')?.value || '';
    if (visibleSort) url.searchParams.set('sort_by', visibleSort);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    return url;
  };

  const syncServerPanel = (currentPanel, sourcePanel) => {
    if (!currentPanel || !sourcePanel) return false;
    const openGroups = new Map([...currentPanel.querySelectorAll('.nbh-prototype-filter-group')]
      .map((group) => [group.querySelector('summary')?.textContent.trim(), group.open]));
    currentPanel.dataset.nbhPriceActive = sourcePanel.dataset.nbhPriceActive || 'false';
    currentPanel.innerHTML = sourcePanel.innerHTML;
    currentPanel.querySelector('[data-nbh-server-filter-form]')?.classList.add('is-enhanced');
    currentPanel.querySelectorAll('.nbh-prototype-filter-group').forEach((group) => {
      const label = group.querySelector('summary')?.textContent.trim();
      if (openGroups.has(label)) group.open = openGroups.get(label);
    });

    return true;
  };

  const refreshCollection = async (shell, targetUrl, { historyMode = 'push', preserveDrawer = false } = {}) => {
    const productGrid = shell.querySelector('#product-grid');
    const sectionId = productGrid?.dataset.id;
    const gridContainer = shell.querySelector('#ProductGridContainer');
    if (!sectionId || !gridContainer) {
      window.location.assign(publicUrlFor(targetUrl).toString());
      return;
    }

    requestController?.abort();
    requestController = new AbortController();

    const preservedScroll = {
      x: window.scrollX,
      y: window.scrollY,
    };
    shell.classList.add('is-filtering');
    gridContainer.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(buildSectionUrl(targetUrl, sectionId), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'NBHCollectionFilter' },
        signal: requestController.signal,
      });
      if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const sourceShell = parsed.querySelector('.nbh-collection-shell');
      const sourceGridContainer = parsed.getElementById('ProductGridContainer');
      const sourceCount = parsed.getElementById('NbhProductCountDesktop');
      const sourcePanel = parsed.querySelector('[data-nbh-server-filter-panel]');

      if (!sourceShell || !sourceGridContainer || !sourceCount) {
        throw new Error('Collection section response was incomplete');
      }

      const drawerWasOpen = preserveDrawer && shell.querySelector('[data-nbh-server-filter-panel]')?.classList.contains('is-open');
      const focusedFilter = drawerWasOpen && document.activeElement?.closest('[data-nbh-server-filter-panel]')
        ? { name: document.activeElement.name, value: document.activeElement.value }
        : null;

      gridContainer.innerHTML = sourceGridContainer.innerHTML;

      const countContainer = shell.querySelector('.nbh-catalog-toolbar__count');
      if (countContainer && sourceCount.parentElement) countContainer.innerHTML = sourceCount.parentElement.innerHTML;

      const sidebar = shell.querySelector('.nbh-catalog-sidebar');
      const currentPanel = sidebar?.querySelector('[data-nbh-server-filter-panel]');
      if (sourcePanel && currentPanel) {
        syncServerPanel(currentPanel, sourcePanel);
      }

      shell.dataset.nbhServerFiltersReady = sourceShell.dataset.nbhServerFiltersReady || 'false';

      const publicUrl = publicUrlFor(targetUrl);
      syncSortState(shell, sourceShell, publicUrl);
      if (historyMode === 'push') {
        history.pushState({ nbhCollectionUrl: publicUrl.toString() }, '', publicUrl);
      } else if (historyMode === 'replace') {
        history.replaceState({ nbhCollectionUrl: publicUrl.toString() }, '', publicUrl);
      }

      if (shell.dataset.nbhServerFiltersReady !== 'true') {
        hideUnavailableFilters(shell);
      } else {
        const currentPanelAfterUpdate = shell.querySelector('[data-nbh-server-filter-panel]');
        const badge = shell.querySelector('[data-nbh-active-count]');
        const checked = currentPanelAfterUpdate?.querySelectorAll('input[data-nbh-filter]:checked').length || 0;
        const priceActive = currentPanelAfterUpdate?.dataset.nbhPriceActive === 'true' ? 1 : 0;
        const total = checked + priceActive;
        if (badge) {
          badge.textContent = String(total);
          badge.hidden = total === 0;
        }
        syncBestsellerVisibility(shell);
      }

      if (drawerWasOpen) {
        const currentPanel = shell.querySelector('[data-nbh-server-filter-panel]');
        currentPanel?.classList.add('is-open');
        currentPanel?.setAttribute('role', 'dialog');
        currentPanel?.setAttribute('aria-modal', 'true');
        shell.querySelector('[data-nbh-filter-overlay]')?.classList.add('is-open');
        shell.querySelector('[data-nbh-filter-open]')?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('nbh-filter-drawer-open');
        const focusTarget = [...(currentPanel?.querySelectorAll('[name]') || [])]
          .find((input) => input.name === focusedFilter?.name && input.value === focusedFilter?.value);
        (focusTarget || currentPanel?.querySelector('[data-nbh-filter-close]'))?.focus({ preventScroll: true });
      }

      const restoreScroll = () => {
        window.scrollTo({
          left: preservedScroll.x,
          top: preservedScroll.y,
          behavior: 'auto',
        });
      };

      restoreScroll();
      requestAnimationFrame(() => {
        restoreScroll();
        requestAnimationFrame(restoreScroll);
      });

      document.dispatchEvent(new CustomEvent('nbh:collection:updated', { detail: { url: publicUrl.toString() } }));
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('[NBH] Smooth collection update failed; using normal navigation.', error);
      window.location.assign(publicUrlFor(targetUrl).toString());
    } finally {
      shell.classList.remove('is-filtering');
      shell.querySelector('#ProductGridContainer')?.removeAttribute('aria-busy');
    }
  };

  const createServerController = (shell) => {
    const sidebar = shell.querySelector('.nbh-catalog-sidebar');
    const toolbar = shell.querySelector('.nbh-catalog-toolbar');
    const panel = sidebar?.querySelector('[data-nbh-server-filter-panel]');
    const form = panel?.querySelector('[data-nbh-server-filter-form]');
    const trigger = toolbar?.querySelector('[data-nbh-filter-open]');

    if (!sidebar || !toolbar || !panel || !form) return false;

    let overlay = shell.querySelector('[data-nbh-filter-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'nbh-filter-drawer-overlay';
      overlay.dataset.nbhFilterOverlay = '';
      shell.appendChild(overlay);
    }

    const setDrawer = (open, { returnFocus = true } = {}) => {
      panel.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('nbh-filter-drawer-open', open);
      trigger?.setAttribute('aria-expanded', String(open));

      if (open && DRAWER_MEDIA.matches) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        requestAnimationFrame(() => {
          const closeButton = panel.querySelector('[data-nbh-filter-close]');
          (closeButton || visibleFocusableElements(panel)[0] || panel).focus();
        });
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        if (!open && returnFocus && trigger && DRAWER_MEDIA.matches) {
          requestAnimationFrame(() => trigger.focus());
        }
      }
    };

    if (trigger && trigger.dataset.nbhDrawerBound !== 'true') {
      trigger.addEventListener('click', () => setDrawer(true, { returnFocus: false }));
      trigger.dataset.nbhDrawerBound = 'true';
    }

    if (panel.dataset.nbhDialogBound !== 'true') {
      panel.addEventListener('keydown', (event) => {
        if (!panel.classList.contains('is-open') || !DRAWER_MEDIA.matches) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          setDrawer(false);
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = visibleFocusableElements(panel);
        if (!focusable.length) {
          event.preventDefault();
          panel.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (!panel.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
      });
      panel.dataset.nbhDialogBound = 'true';
    }

    panel.addEventListener('click', (event) => {
      if (event.target.closest('[data-nbh-filter-close]')) setDrawer(false);
    });

    overlay.onclick = () => setDrawer(false);

    panel.addEventListener('submit', (event) => {
      const activeForm = event.target.closest('[data-nbh-server-filter-form]');
      if (!activeForm) return;
      event.preventDefault();
      const params = buildFilterParams(activeForm);
      const url = new URL(window.location.pathname, window.location.origin);
      url.search = params.toString();
      refreshCollection(shell, url, { preserveDrawer: true });
    });

    let priceInputTimer;
    panel.addEventListener('input', (event) => {
      if (!event.target.matches('input[name^="filter.v.price."]')) return;
      window.clearTimeout(priceInputTimer);
      priceInputTimer = window.setTimeout(() => event.target.closest('form')?.requestSubmit(), 600);
    });

    panel.addEventListener('change', (event) => {
      if (event.target.matches('input[data-nbh-filter], input[name^="filter.v.price."]')) {
        event.target.closest('form')?.requestSubmit();
      }
    });

    if (panel.dataset.nbhDelegatedClicksBound !== 'true') {
      panel.addEventListener('click', (event) => {
        const link = event.target.closest?.('a.nbh-prototype-filter-option--price, .nbh-prototype-filter-chip, .nbh-prototype-filter-clear');
        if (!link || !panel.contains(link)) return;
        event.preventDefault();
        refreshCollection(shell, withCurrentSort(shell, link.href), { preserveDrawer: true });
      });
      panel.dataset.nbhDelegatedClicksBound = 'true';
    }

    shell.dataset.nbhCustomFilters = 'ready';
    shell.dataset.nbhFilterEngine = 'server';
    form.classList.add('is-enhanced');

    if (trigger) {
      trigger.hidden = false;
      trigger.disabled = false;
      trigger.removeAttribute('aria-disabled');
    }

    const checked = panel.querySelectorAll('input[data-nbh-filter]:checked').length;
    const priceActive = panel.dataset.nbhPriceActive === 'true' ? 1 : 0;
    const total = checked + priceActive;
    const badge = trigger?.querySelector('[data-nbh-active-count]');
    if (badge) {
      badge.textContent = String(total);
      badge.hidden = total === 0;
    }
    syncBestsellerVisibility(shell);

    return true;
  };

  const boot = () => {
    if (migrateLegacyFilterUrl()) return;
    polishSort();

    document.querySelectorAll('.nbh-collection-shell').forEach((shell) => {
      if (shell.dataset.nbhFilterEngineInitialized === 'true') return;

      if (shell.dataset.nbhFilteringEnabled !== 'true') {
        shell.dataset.nbhCustomFilters = 'ready';
        shell.dataset.nbhFilterEngine = 'server';
        shell.dataset.nbhFilterEngineInitialized = 'true';
        return;
      }

      if (shell.dataset.nbhServerFiltersReady === 'true' && createServerController(shell)) {
        shell.dataset.nbhFilterEngineInitialized = 'true';
        return;
      }

      hideUnavailableFilters(shell);
      shell.dataset.nbhFilterEngineInitialized = 'true';
    });
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('.nbh-catalog-sort select[name="sort_by"]');
    if (!select) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const shell = select.closest('.nbh-collection-shell');
    if (!shell || shell.dataset.nbhFilterEngine !== 'server') {
      const fallbackUrl = new URL(window.location.href);
      fallbackUrl.searchParams.set('sort_by', select.value);
      fallbackUrl.searchParams.delete('page');
      window.location.assign(fallbackUrl.toString());
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    refreshCollection(shell, url);
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.nbh-collection-shell[data-nbh-filter-engine="server"] .pagination-wrapper a');
    if (!link) return;
    event.preventDefault();
    const shell = link.closest('.nbh-collection-shell');
    refreshCollection(shell, link.href);
  });

  window.addEventListener('popstate', () => {
    const shell = document.querySelector('.nbh-collection-shell[data-nbh-filter-engine="server"]');
    if (!shell) return;
    refreshCollection(shell, window.location.href, { historyMode: 'none' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(boot));
  document.addEventListener('shopify:section:select', () => requestAnimationFrame(boot));
})();
